import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AccTeamMentor } from '@interfaces';
import { AccTeamDialogDataService } from '../../acc-team-dialog-data.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialogService: DialogService, dialogDataService: AccTeamDialogDataService): GridSetup<AccTeamMentor> {

	return {
		rowName: { singular: 'Mentor', plural: 'Mentors' },
		getRowKey: row => '' + row.accMentorId,
		stateKey: 'acc-team-mentors-grid',
		actions: getActions(dialogService, dialogDataService),
		buttons: getButtons(dialogService, dialogDataService),
		columns: getColumns(util),
	}
}
